import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CallIcon from "../Assets/mobile.png";
import WhatsappIcon from "../Assets/whatsapp_color.png";
import Styles from "./SupportContactModal.module.css";

export default function SupportContactModal({ show, onClose, phone }) {
  const getFormattedWhatsappNumber = (rawPhone) => {
    if (!rawPhone) return "";
    let clean = String(rawPhone).trim().replace(/\D/g, "");
    // Remove leading zero if present
    if (clean.startsWith("0")) {
      clean = clean.substring(1);
    }
    // If already 12 digits starting with 91, country code is present
    if (clean.length === 12 && clean.startsWith("91")) {
      return clean;
    }
    // If standard 10-digit Indian mobile number, attach 91
    if (clean.length === 10) {
      return `91${clean}`;
    }
    // If already starts with 91
    if (clean.startsWith("91")) {
      return clean;
    }
    // Fallback: attach 91
    return `91${clean}`;
  };

  const handleCall = () => {
    window.location.href = `tel:${phone}`;
  };

  const handleWhatsapp = () => {
    const formattedPhone = getFormattedWhatsappNumber(phone);
    if (formattedPhone) {
      window.open(`https://wa.me/${formattedPhone}`, "_blank");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      contentClassName={Styles.modalContent}
    >
      <Modal.Header closeButton>
        <Modal.Title>Contact Support</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className={Styles.actionContainer}>
          <button
            className={`${Styles.actionBtn} ${Styles.call}`}
            onClick={handleCall}
          >
            <img className={Styles.icon} src={CallIcon} alt="DialPad" />
            <span>Call</span>
          </button>

          <button
            className={`${Styles.actionBtn} ${Styles.whatsapp}`}
            onClick={handleWhatsapp}
          >
            <img className={Styles.icon} src={WhatsappIcon} alt="Whatsapp" />
            <span>WhatsApp</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
